module.exports = __webpack_public_path__ + "static/media/Logo.8962d9a8.svg";